import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-resend-email-dialog',
  templateUrl: './email-resend-email-dialog.component.html',
  styleUrls: ['./email-resend-email-dialog.component.scss']
})
export class EmailResendEmailDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
